export default "__VITE_ASSET__bfde9261__"